export default __webpack_public_path__ + "static/char-37-anr-c88869ecf9435aab03e9797316a099f5.webp";